import React, {useState} from "react";
function FaqItem({question, answer}){
    const[isOpen, setIsOpen] = useState(false);

    return(
        <div className="border-4 border-[#303030] rounded-3xl">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex justify-between items-center w-full p-5 text-2xl text-left font-semibold text-justify px-8"
                >
                    <span>{question}</span>

                    <svg
                        className={`w-5 h-5 trnasform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmnls="http://www.w3.org/2000/svg"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </button>

                {isOpen && (
                    <div className="p-5 px-8 pt-0 text-lime-200 text-[18px] text-justify">
                        <p className="whitespace-pre-line">{answer}</p>
                    </div>
                )}
        </div>
    );
}

export default FaqItem;